var React = require('react');

function TriangleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 11L-7.97623e-09 22L9.53674e-07 -4.37114e-07L10 11Z","fill":"currentColor"}));
}

TriangleInline.defaultProps = {"width":"10","height":"22","viewBox":"0 0 10 22","fill":"none"};

module.exports = TriangleInline;

TriangleInline.default = TriangleInline;
